<div class="loaderImageContainer" #loaderPopover popover="manual" *ngIf="R.loadingCalls?.length > 0">
    <div class="loader">
        <div class="css-dot-spinner">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
    <div class="loaderMessage">
        <ng-container *ngIf="R.loadingCalls?.length > 0">
            <ng-container *ngIf="R.loadingCalls[0]">
                <div *ngIf="R.loadingCalls[0].message" [textContent]="R.loadingCalls[0].message"></div>
            </ng-container>
        </ng-container>
    </div>
</div>
